import React from 'react';
import AccountList from './AccountList';

const SourcesAccounts = () => {
  return <AccountList baseAccountId={21} />;
};

export default SourcesAccounts;
